// Przestrzeń nazw 'settings': ekran Ustawienia (zakładki), wiadomość powitalna, cele przekierowań,
// obsługa rozmów (komponent dziś nieużywany na ekranie, ale przetłumaczony) i wybór firmy.
//
// VERIFY: cały plik poza etykietą zakładki „Godziny pracy". Mockup ma sekcję „Ustawienia asystenta"
// z przełącznikami (numer asystenta, odbieranie po godzinach pracy, przekazywanie do urzędnika…),
// a nasz ekran to zakładki z ręcznie edytowaną wiadomością powitalną, godzinami pracy i celami
// przekierowań.
export default {
  tabs: {
    initialMessage: 'Wiadomość początkowa',
    // Termin ze słownika projektu.
    businessHours: 'Godziny pracy',
    redirectionTargets: 'Cele przekierowań',
  },
  companySelect: {
    // Używane też jako placeholder wyboru firmy na ekranach numerów i głosów.
    placeholder: 'Wybierz firmę',
  },
  initialMessage: {
    hint: 'Powitanie, które asystent odczytuje, gdy dzwoni mieszkaniec.',
    // <var> = kod zmiennej, np. {user_name}. Pojedyncze klamry to nie interpolacja i18next.
    variables:
      'W wiadomościach można użyć zmiennych dynamicznych: <var>{user_name}</var> i <var>{assistant_name}</var>. Zostaną zastąpione rzeczywistymi wartościami podczas wyświetlania wiadomości.',
    example:
      '<b>przykład:</b> Dzień dobry <var>{user_name}</var>. Jestem <var>{assistant_name}</var>, wirtualny asystent.',
    welcomeLabel: 'Wiadomość powitalna:',
    notCreated: 'nie utworzono',
  },
  redirectionTargets: {
    hint: 'Numery, na które asystent przekazuje rozmowę, gdy dzwoniący prosi o kontakt z człowiekiem.',
    add: 'Dodaj cel przekierowania',
    count: 'Liczba celów:',
    empty: 'Nie znaleziono celów przekierowań',
    loadError: {
      title: 'Nie udało się załadować celów przekierowań',
      description: 'Lista jest teraz niedostępna. Odśwież stronę, aby spróbować ponownie.',
    },
    row: {
      phone: 'Telefon:',
      afterHoursPhone: 'Telefon po godzinach:',
      aliases: 'Aliasy:',
      email: 'Adres e-mail:',
      extension: 'Numer wewnętrzny:',
    },
    // Etykiety dostępności przycisków-ikon. Telefon dopisany, bo sama nazwa nie jest unikalna.
    editLabel: 'Edytuj {{name}}, {{phone}}',
    deleteLabel: 'Usuń {{name}}, {{phone}}',
    deleteModal: {
      title: 'Usuń cel przekierowania',
      content: 'Czy na pewno usunąć ten cel przekierowania? Tej operacji nie można cofnąć.',
    },
    modal: {
      createTitle: 'Dodaj nowy cel przekierowania',
      editTitle: 'Edytuj cel przekierowania',
      createSubtitle: 'Utwórz nowy cel przekierowania połączeń',
      editSubtitle: 'Zaktualizuj dane celu przekierowania',
      fields: {
        name: 'Nazwa',
        phone: 'Telefon',
        afterHoursPhone: 'Telefon po godzinach',
        aliases: 'Aliasy',
        email: 'Adres e-mail',
        extension: 'Numer wewnętrzny',
      },
      placeholders: {
        name: 'Podaj nazwę',
        // VERIFY: przykład z testów Kacpra (starostwo), brak w mockupie.
        aliases: 'np. wydział komunikacji, rejestracja pojazdów, prawo jazdy',
      },
      // VERIFY: brak w mockupie.
      help: {
        aliases:
          'Oddziel przecinkami. Po tych słowach asystent rozpoznaje, że dzwoniący chce trafić właśnie tutaj.',
        afterHoursPhone:
          'Opcjonalny. Używany po godzinach pracy, gdy asystent proponuje pocztę głosową wydziału.',
      },
      validation: {
        nameRequired: 'Podaj nazwę',
        nameTaken: 'Cel o tej nazwie już istnieje',
        phoneRequired: 'Podaj numer telefonu',
        phoneInvalid: 'Podaj numer z kierunkowym: +48 i 9 cyfr, np. +48 511 827 904',
      },
      saveFailed: 'Nie udało się zapisać celu przekierowania.',
    },
  },
  callHandler: {
    title: 'Obsługa rozmów',
    hint: 'Wybierz, który system obsługuje rozmowy przychodzące w tej firmie.',
    raiBot: {
      label: 'Bot RAI',
      description: 'Rozmowy obsługuje wbudowany bot VoiceSphere oparty na LLM.',
    },
    elevenLabs: {
      label: 'Agent ElevenLabs',
      description:
        'Rozmowy obsługuje konwersacyjny agent ElevenLabs. Agent musi być wcześniej opublikowany.',
    },
    agentLabel: 'Wybierz opublikowanego agenta',
    agentPlaceholder: 'Wybierz agenta',
    noPublishedAgents: {
      title: 'Brak opublikowanych agentów',
      description:
        'Aby przełączyć obsługę, trzeba najpierw utworzyć i opublikować agenta ElevenLabs. Agenta można utworzyć na stronie Agenci.',
    },
    selectAgentFirst: 'Wybierz opublikowanego agenta',
    confirm: {
      title: 'Zmień obsługę rozmów',
      elevenLabs:
        'Czy na pewno przełączyć wszystkie rozmowy przychodzące na agenta ElevenLabs? Zmieni to sposób obsługi wszystkich rozmów przychodzących w tej firmie.',
      rai: 'Czy na pewno przełączyć wszystkie rozmowy przychodzące z powrotem na bota RAI? Zmieni to sposób obsługi wszystkich rozmów przychodzących w tej firmie.',
    },
    switched: {
      elevenLabs: 'Przełączono na agenta ElevenLabs',
      rai: 'Przełączono z powrotem na bota RAI',
      failed: 'Nie udało się zmienić obsługi rozmów',
    },
    handoff: {
      title: 'Routing przekazań do urzędnika',
      hint: 'Gdy opcja jest włączona, dzwoniący proszący o kontakt z urzędnikiem trafiają na wstrzymanie w kolejce Command Center, gdzie urzędnik przejmuje rozmowę w przeglądarce (WebRTC), zamiast być łączeni przez PSTN z numerem call center. Przekazania do konkretnej osoby (opiekun sprawy, przełożony, poczta głosowa) zawsze idą ścieżką PSTN, niezależnie od tego ustawienia.',
      statusEnabled: 'Kierowanie do kolejki Command Center',
      statusDisabled: 'Kierowanie na numer call center przez PSTN',
      confirm: {
        title: 'Zmień routing przekazań',
        enabled:
          'Czy na pewno kierować ogólne przekazania do call center do kolejki Command Center? Urzędnicy będą musieli pracować w przeglądarkowym Command Center w słuchawkach.',
        disabled:
          'Czy na pewno kierować ogólne przekazania do call center na skonfigurowany numer call center przez PSTN?',
      },
      switched: {
        enabled: 'Przekazania kierowane do kolejki Command Center',
        disabled: 'Przekazania kierowane do call center przez PSTN',
        failed: 'Nie udało się zmienić routingu przekazań',
      },
    },
  },
  languageSwitch: {
    showEnglish: 'Pokaż tłumaczenie na angielski',
    showOriginal: 'Pokaż język oryginału',
    originalFlagAlt: 'Flaga języka oryginału',
  },
} as const;
